// JavaScript for acf_blocks/featured-cards-block
(($) => {
  "use strict";
  console.log("featured-cards-block.js");

  const cards = document.querySelectorAll(".eat-shop-play-block .col-md-4");
  const HAS_HOVER      = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  const IS_TOUCH_ONLY  = !HAS_HOVER;               // tablets/phones típicos

  cards.forEach((card) => {
    const img = card.querySelector(".esp-zoom-img");
    if (!img) return;

    const tl = gsap.timeline({ paused: true })
                  .to(img, { scale: 1.15, duration: 0.6, ease: "power2.out" });

    /* ----- Desktop (mouse / trackpad) ----- */
    if (HAS_HOVER) {
      card.addEventListener("mouseenter", () => tl.play());
      card.addEventListener("mouseleave", () => tl.reverse());
      return;                        // nada de touch-fix necessário
    }

    card.addEventListener("click", (e) => {
      if (e.target.closest("a")) return;
      tl.reversed() ? tl.play() : tl.reverse();
    }, { passive: true });          
  });

  $(document).ready(() => {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
    gsap.registerPlugin(ScrollTrigger);
    gsap.set(".animation-top-featured", { y: 40, autoAlpha: 0 });
    gsap.timeline({
      defaults: { ease: "power3.out" },
      scrollTrigger: {
        trigger: ".animation-top-featured",
        start: "top 75%",
        toggleActions: "play none none none"
      }
    })
    .to(".animation-top-featured", {
      duration: 1,
      y: 0,
      autoAlpha: 1,
      stagger: 0.1
    });
  });
})(jQuery);
